import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var PencilSquareSvg = function PencilSquareSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22 6.68 17.32 2l-8.024 8.025v4.68h4.679zm-11.245 6.566v-2.617l6.566-6.566 2.616 2.617-6.566 6.566z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.849 4.126H2V22h17.874v-9.849h-1.46v8.39H3.46V5.585h8.39z"
  }));
};
export var PencilSquare = function PencilSquare(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: PencilSquareSvg
  }));
};